import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);


const routes = [
  {
    path: "/",
    component:  () => import("../views/shinsotsu.vue"),
    children: [
      { path: "/", component: () => import("../views/shinsotsu-saiyou.vue") },
      { path: "/kakunin", component: () => import("../views/kakunin-form.vue") },
      { path: "/soushin", component: () => import("../views/soushin-kanryo.vue") },
      { path: '/from/:id', component:() => import("../components/save-id.vue"),}
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  next();
})
export default router;
